export const companyPortfolio = {
  'companyPortfolio.portfolioTitle': 'Portfolio',

  'companyPortfolio.productAndServices': 'Our product & services',

  'companyPortfolio.modalTitle': 'Edit portfolio',
  'companyPortfolio.modalPortfolioPlaceholderText': 'Enter portfolio',
}
